export const formatSearchPath = (path: string | string[]) => {
    if (!Array.isArray(path)) {
        return path;
    }

    const formattedSearchPath = path.filter((value) => {
        return !['property', 'houses', 'flats', 'retirement'].includes(value);
    });

    return formattedSearchPath
        .map((path) => {
            return path.replace(/-/, ' ');
        })
        .reverse()
        .join(', ');
};
